import React, { useState } from "react";
import styles from "./ReservationStrip.module.css";
import Reservations from "../Reservations/Reservations";

const ReservationStrip = () => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <section className={styles.strip}>
                <div className={styles.content}>
                    <h2>EXPERIENCE LUXURY AT IT’S FINEST</h2>

                    <button
                        className={styles.reserveBtn}
                        onClick={() => setOpen(true)}
                    >
                        Reserve A Table
                    </button>
                </div>
            </section>

            {open && (
                <Reservations
                    isPopup={true}
                    onClose={() => setOpen(false)}
                />
            )}
        </>
    );
};

export default ReservationStrip;
